/**
 * @generated SignedSource<<1217bbd1bae6928270b724886ae3f02d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type taskExecutionListCombineCheckTaskExecutions$data = ReadonlyArray<{
  readonly checkValue: TaskSentiment | null;
  readonly " $fragmentType": "taskExecutionListCombineCheckTaskExecutions";
}>;
export type taskExecutionListCombineCheckTaskExecutions$key = ReadonlyArray<{
  readonly " $data"?: taskExecutionListCombineCheckTaskExecutions$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskExecutionListCombineCheckTaskExecutions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "taskExecutionListCombineCheckTaskExecutions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "808635625436add481f576921dc12931";

export default node;
